import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from '@mui/material';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ bgcolor: '#1a1a2e', color: 'white', pt: 6, pb: 3 }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Company Info */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <img
                                src="/Brand_logo.svg"
                                alt="Brand Logo"
                                style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    height: '48px',
                                    marginRight: '12px'
                                }}
                            />
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Ramdayal Rameshwar Lal
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ mb: 2, color: '#b0b0b0', lineHeight: 1.7 }}>
                            Your trusted partner in quality food products since 1966.
                            We deliver excellence in every grain, committed to serving our customers with integrity and quality.
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                                sx={{
                                    color: 'white',
                                    bgcolor: '#2563eb',
                                    '&:hover': { bgcolor: '#1d4ed8' }
                                }}
                                size="small"
                            >
                                <Facebook size={18} />
                            </IconButton>
                            <IconButton
                                sx={{
                                    color: 'white',
                                    bgcolor: '#e1306c',
                                    '&:hover': { bgcolor: '#c13584' }
                                }}
                                size="small"
                            >
                                <Instagram size={18} />
                            </IconButton>
                        </Box>
                    </Grid>

                    {/* Quick Links */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                onClick={() => navigate('/')}
                                sx={{
                                    color: '#b0b0b0',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    '&:hover': { color: 'white', textDecoration: 'underline' }
                                }}
                            >
                                Home
                            </Link>
                            <Link
                                onClick={() => navigate('/about')}
                                sx={{
                                    color: '#b0b0b0',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    '&:hover': { color: 'white', textDecoration: 'underline' }
                                }}
                            >
                                About Us
                            </Link>
                            <Link
                                onClick={() => navigate('/products')}
                                sx={{
                                    color: '#b0b0b0',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    '&:hover': { color: 'white', textDecoration: 'underline' }
                                }}
                            >
                                All Products
                            </Link>
                            <Link
                                onClick={() => navigate('/login')}
                                sx={{
                                    color: '#b0b0b0',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    '&:hover': { color: 'white', textDecoration: 'underline' }
                                }}
                            >
                                Login
                            </Link>
                        </Box>
                    </Grid>

                    {/* Products */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Our Products
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                Premium Rice
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                Quality Wheat
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                Fresh Pulses
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                Organic Grains
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                Premium Spices
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Contact Info */}
                    <Grid item xs={12} md={3}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Contact Us
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                <MapPin size={18} style={{ marginTop: '2px', flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                    Near Jain School, Natho Talab<br />
                                    Sujangarh, Rajasthan - 331507<br />
                                    India
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Phone size={18} style={{ flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                    +91-9351375631
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Mail size={18} style={{ flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                                    mangluniasajendra@gmail.com
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.1)' }} />

                {/* Copyright & Developer Credit */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                        © {new Date().getFullYear()} Ramdayal Rameshwar Lal. All rights reserved.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                        <Typography variant="body2" sx={{ color: '#b0b0b0' }}>
                            Developed by{' '}
                            <Link
                                href="mailto:sanidhyamanglunia@gmail.com"
                                sx={{
                                    color: '#60a5fa',
                                    textDecoration: 'none',
                                    '&:hover': { textDecoration: 'underline' }
                                }}
                            >
                                Sanidhya Manglunia
                            </Link>
                        </Typography>
                        <Link
                            href="tel:+916375907153"
                            sx={{
                                color: '#b0b0b0',
                                textDecoration: 'none',
                                fontSize: '0.875rem',
                                '&:hover': { color: 'white' }
                            }}
                        >
                            +91-6375907153
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;